import { Button, Toast } from 'primereact'
import React, { useRef } from 'react'
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { EnviarCorreo } from '../../../../Base/Services/Email/EnviarCorreo';
import { useState } from 'react';
import { toastShow } from '../../../../Base/Services/ToastService';

import './QRVisitas.scss'
import { useParams } from 'react-router-dom';


const QRVisitas = ({ show }) => {

    const [loading, setLoading] = useState(false)
    const toast = useRef(null)
    const { NoVisita } = useParams();

    const descargarImagen = () => {
        setLoading(true);
        const qr = document.getElementById('qrContent');
        html2canvas(qr).then(canvas => {
            var link = document.createElement('a');
            link.href = canvas.toDataURL('image/png');
            let Nombre = show ? show?.NoVisita : NoVisita
            link.download = Nombre + '.png';
            link.click();
        })
        setLoading(false);
    }

    const descargarPDF = () => {
        // imprimir #qrContent
        const qr = document.getElementById('qrContent');
        html2canvas(qr).then(canvas => {
            var imgData = canvas.toDataURL('image/png');
            var pdf = new jsPDF('p', 'pt', 'letter');
            var width = pdf.internal.pageSize.getWidth();
            var height = pdf.internal.pageSize.getHeight();
            pdf.addImage(imgData, 'PNG', 100, 50, 400, 300);
            let Nombre = show ? show?.NoVisita : NoVisita
            pdf.save(Nombre + ".pdf");
        })
    }

    // copiar url
    const copiarURL = () => {
        const url = `${process.env.REACT_APP_PUBLIC_URL}` + '/QRVisitas/' + show?.NoVisita;
        navigator.clipboard.writeText(url);
        toastShow(toast, 'success', 'URL copiada.');
    }

    // enviar imagen por correo
    const enviarCorreo = () => {
        setLoading(true);
        const body = document.getElementById('qrContent');
        html2canvas(body).then(async (canvas) => {
            var imgData = canvas.toDataURL('image/png');
            var pdf = new jsPDF('p', 'mm', 'a4');
            var width = pdf.internal.pageSize.getWidth();
            var height = pdf.internal.pageSize.getHeight();
            pdf.addImage(imgData, 'PNG', 0, 0, width, height);

            const result = await EnviarCorreo(
                setLoading,
                toast,
                toastShow,
                body.innerHTML,
                'luisitomedina95@gmail.com',
                show?.NoVisita,
                '',
                '',
                [{
                    filename: `${show?.NoVisita}.pdf`,
                    path: pdf.output('datauristring')
                }]
            );
        })

        setLoading(false);
    }

    return (
        <div className='Light p-4'>
            <Toast ref={toast} />
            <div id='qrContent' className='d-flex ' style={{ justifyContent: 'center', maxWidth: 500, margin: 'auto'  }}>
                <div className='' style={{ display: 'flex', padding: 10, justifyContent: 'center', flexDirection: 'column', alignItems: 'center', }}>
                    <QRCodeSVG
                        value={`
                        {
                        "NoVisita": "${show?.NoVisita ? show?.NoVisita : NoVisita}", 
                        "navega": "Registro visita"
                        }
                        `}
                        size={300}
                        bgColor={"#ffffff"}
                        fgColor={"#000000"}
                        level={"M"}
                        renderAs={"svg"}
                        includeMargin={true}
                        imageSettings={{
                            src: "https://were.ppf.com.hn/web/Logo_PPF.png",
                            x: null,
                            y: null,
                            height: 60,
                            width: 60,
                            excavate: true
                        }}
                        imageRendering={"pixelated"}
                    />
                    <h2>{show?.NoVisita ? show?.NoVisita : NoVisita}</h2>
                    <h4>{show?.Motivo}</h4>
                    <h5>{show?.FechaProgramada}</h5>
                </div>
            </div>
            <div className='d-flex gap mt-4' style={{ justifyContent: 'center' }}>
                { !window.location.href.includes('web/IPS/Logistica/') && <Button
                    className=' '
                    onClick={descargarImagen}
                    label='Imagen'
                    icon='pi pi-print'
                    loading={loading}
                />}
                { !window.location.href.includes('web/IPS/Logistica/') && <Button
                    className=''
                    onClick={descargarPDF}
                    label='PDF'
                    icon='pi pi-download'
                    loading={loading}
                />}
                {/* COPIAR URL */}
                <Button
                        className=' '
                        onClick={copiarURL}
                        label='Copiar URL'
                        icon='pi pi-copy'
                    />
                {/* enviar por correo */}
                {/* <Button
                        className=' '
                        onClick={enviarCorreo}
                        label='Correo'
                        icon='pi pi-envelope'
                        loading={loading}
                    /> */}
                {/* enviar por whatsapp */}
                {/* <Button
                        className=' '
                        onClick={onHide}
                        label='Whatsapp'
                        icon='pi pi-whatsapp'
                    /> */}
                {/* <Button
                        className='btn btn-primary'
                        onClick={onHide}
                        label='Cerrar'
                        icon='pi pi-times'
                    /> */}
            </div>
        </div>
    )
}

export default QRVisitas